class BackInStockForm extends HTMLElement {
  constructor() {
    super()

    this.modalProductTitle = this.querySelector('.js-product-title')
    this.modalProductId = this.querySelector('.js-product-id')
    this.modalSelectVariants = this.querySelector('.js-select')
    this.buttonClose = this.querySelector('.js-close')
    this.apiKey = this.dataset.apiKey
    this.errorMessage = this.querySelector('.js-error-message')

    this.form = this.querySelector('form')

    this.addEventListener('click', (event) => {
      const buttonClose = event.target.closest('.js-close')
      const innerContent = event.target.closest('.js-inner-content')
      if (!innerContent || buttonClose) {
        this.clearAllData()
      }
    })

    this.form.addEventListener('submit', (event) => {
      event.preventDefault()
      this.handleFormData(event)
    })
  }

  handleFormData(event) {
    this.form.classList.remove('error-form')
    this.form.classList.remove('success-form')

    const emailInput = this.form.querySelector("input[type=email]");
    const emailValue = emailInput.value;

    if (emailValue === '') {
      this.errorMessage.innerHTML = "Please enter an email address."
      this.form.classList.add('error-form')
      this.errorMessage.classList.remove('hidden')
      return;
    }

    if (!this.validateEmail(emailValue)) {
      this.errorMessage.innerHTML = "Please enter a valid email"
      this.form.classList.add('error-form')
      this.errorMessage.classList.remove('hidden')
      return;
    }

    // Log form data for debugging
    console.log('Form submission - form:', this.form);
    console.log('Product ID input:', this.modalProductId);
    console.log('Variant Select:', this.modalSelectVariants);
    
    // Get variant ID directly from the select element
    let variantId = '';
    if (this.modalSelectVariants) {
      variantId = this.modalSelectVariants.value;
      console.log('Selected Variant ID:', variantId);
    }

    // Format the variant ID for Klaviyo API
    let formattedVariantId = variantId;
    if (variantId && !variantId.includes(':::')) {
      formattedVariantId = `$shopify:::$default:::${variantId}`;
    }
    console.log('Formatted Variant ID for API:', formattedVariantId);

    // Create the payload with correct structure for Klaviyo API
    const payload = {
      data: {
        type: "back-in-stock-subscription",
        attributes: {
          profile: {
            data: {
              type: "profile",
              attributes: {
                email: emailValue
              }
            }
          },
          channels: ["EMAIL"]
        },
        relationships: {
          variant: {
            data: {
              type: "catalog-variant",
              id: formattedVariantId
            }
          }
        }
      }
    };

    console.log('API Payload:', JSON.stringify(payload, null, 2));

    // Create the URL with the API key
    const url = `https://a.klaviyo.com/client/back-in-stock-subscriptions?company_id=${encodeURIComponent(this.apiKey)}`;
    console.log('API URL:', url);
    
    fetch(url, {
      method: "POST",
      headers: {
        'Accept': 'application/vnd.api+json',
        'Content-Type': 'application/vnd.api+json',
        'Revision': '2025-04-15'
      },
      body: JSON.stringify(payload)
    })
    .then(response => {
      console.log('API Response Status:', response.status);
      
      if (response.ok) {
        return response.json().catch(() => ({})); // Handle empty response
      } else {
        return response.text().then(text => {
          console.error('Error Response Text:', text);
          try {
            return JSON.parse(text);
          } catch (e) {
            return { error: text };
          }
        }).then(data => {
          console.error('Server error details:', data);
          throw new Error(`Server responded with status: ${response.status}`);
        });
      }
    })
    .then(data => {
      console.log('API Success Response:', data);
      
      // Show success state
      this.form.classList.add('success-form');
      
      // Find and disable the select element and email input
      const selectEl = this.form.querySelector('.js-select');
      const inputEl = this.form.querySelector('input[type="email"]');

      if (selectEl) selectEl.setAttribute('disabled', 'disabled');
      if (inputEl) inputEl.setAttribute('disabled', 'disabled');
      
      // Success message is already configured in HTML to show when success-form class is added
    })
    .catch(error => {
      console.error('Error:', error);
      this.errorMessage.innerHTML = "A network error occurred. Please try again.";
      this.form.classList.add('error-form');
      this.errorMessage.classList.remove('hidden');
    });
  }

  clearAllData() {
    this.classList.remove('active')
    document.body.classList.remove('overflow-hidden')

    if (this.modalProductTitle) {
      this.modalProductTitle.innerHTML = 'Product'
    }

    if (this.modalProductId) {
      this.modalProductId.value = ''
    }

    if (this.modalSelectVariants) {
      this.modalSelectVariants.innerHTML = ''
    }
  }

  validateEmail(email) {
    const re = /\S+@\S+\.\S+/;
    return re.test(email);
  }
}

customElements.define('back-in-stock-form', BackInStockForm)

// Add the BackInStockButton class implementation
class BackInStockButton extends HTMLElement {
  constructor() {
    super()

    this.button = this.querySelector('.js-button')
    this.productInfoEl = this.querySelector('.js-product')
    this.productId = this.productInfoEl && this.productInfoEl.dataset.id
    this.productTitle = this.productInfoEl && this.productInfoEl.dataset.title
    this.productVariantEls = this.querySelectorAll('.js-variant-item')
    
    this.modal = document.querySelector('back-in-stock-form')
    this.modalProductTitle = this.modal?.querySelector('.js-product-title')
    this.modalProductId = this.modal?.querySelector('.js-product-id')
    this.modalSelectVariants = this.modal?.querySelector('.js-select')

    this.button.addEventListener('click', () => {
      this.modal.classList.add('active')
      document.body.classList.add('overflow-hidden')
      
      if (this.modalProductTitle) {
        this.modalProductTitle.innerHTML = this.productTitle
      }

      if (this.modalProductId) {
        this.modalProductId.value = this.productId
      }

      if (this.productVariantEls.length > 0 && this.modalSelectVariants) {
        this.productVariantEls.forEach(variant => {
          const value = variant.dataset.value
          const title = variant.dataset.title
          
          if (value && title) {
            const option = document.createElement('option')
            option.text = title
            option.value = value
            this.modalSelectVariants.add(option)
          }
        })
      }
    })
  }
}

customElements.define('back-in-stock-button', BackInStockButton)